const experiments = [
  /* {
    name: 'Arrow',
    link: 'https://www.supah.it/arrow/',
    tags: ['webgl', 'threejs', 'shaders'],
    image: 'images/arrow.webp',
  }, */
  {
    name: 'Asics Poster',
    link: 'https://www.supah.it/asics-poster/',
    tags: ['webgl', 'threejs', 'shaders'],
    image: 'images/asics-poster.webp',
  },
  /* {
    name: 'Audio Visualizer',
    link: 'https://www.shadertoy.com/view/3dGyRh',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/audio-visualizer.webp',
  }, */
  {
    name: 'Biglia',
    link: 'https://supahfunk.github.io/biglia/',
    tags: ['webgl', 'threejs', 'shaders'],
    image: 'images/biglia.webp',
  },
  {
    name: 'Breathe 1',
    link: 'https://www.supah.it/breathe/',
    tags: ['webgl', 'threejs', 'shaders'],
    image: 'images/breathe-ball.webp',
  },
  /* {
    name: 'Breathe 2',
    link: 'https://codepen.io/supah/full/OJXJgZq',
    tags: ['canvas', 'codepen'],
    image: 'images/breathe-lines.webp',
  }, */
  {
    name: 'Breathe 2 glsl',
    link: 'https://www.shadertoy.com/view/NddXzH',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/breathe-glsl.webp',
  },
  {
    name: 'Chroma Gradients',
    link: 'https://www.shadertoy.com/view/mtKfDG',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/chroma-gradients.webp',
  },
  /* {
    name: 'Caustics',
    link: 'https://www.shadertoy.com/view/sdV3zh',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/caustics.webp',
  }, */
  /* {
    name: 'Circle Inception',
    link: 'https://gy799n.csb.app/',
    tags: ['canvas', 'react'],
    image: 'images/circle-inception.webp',
  }, */
  {
    name: 'Carousel with drag and wheel',
    link: 'https://codepen.io/supah/full/abVGjVq',
    tags: ['css', 'codepen'],
    image: 'images/carousel-drag-wheel.webp',
  },
  {
    name: 'Circle Aberration',
    link: 'https://www.shadertoy.com/view/4cyGWV',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/circle-aberration.webp',
  },
  {
    name: 'Coronoarie',
    link: 'https://www.shadertoy.com/view/M3dXzB',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/coronarie.webp',
  },
  {
    name: 'Countdown',
    link: 'https://codepen.io/supah/full/abVGjVq',
    tags: ['svg', 'codepen'],
    image: 'images/countdown.webp',
  },
  {
    name: 'Curly Gradient Line',
    link: 'https://www.shadertoy.com/view/Dt23RK',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/curly-gradient-line.webp',
  },
  /* {
    name: 'Curl',
    link: 'https://www.supah.it/curl/',
    tags: ['webgl', 'threejs', 'shaders'],
    image: 'images/curl.webp',
  }, */
  /* {
    name: 'Desert Snake',
    link: 'https://www.shadertoy.com/view/tlyyzK',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/desert-snake.webp',
  }, */
  {
    name: 'Discotec',
    link: 'https://www.shadertoy.com/view/fdV3zW',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/discotec.webp',
  },
  {
    name: 'Discotec 2',
    link: 'https://www.shadertoy.com/view/DtXfDr',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/discoteq2.webp',
  },
  {
    name: 'Drop Skin',
    link: 'https://codepen.io/supah/full/qBEvEaG',
    tags: ['canvas', 'codepen'],
    image: 'images/drop-skin.webp',
  },
  {
    name: 'Erba',
    link: 'https://www.supah.it/erba/',
    tags: ['webgl', 'threejs', 'shaders'],
    image: 'images/erba.webp',
  },
  {
    name: 'Eye',
    link: 'https://www.shadertoy.com/view/csl3R4',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/eye.webp',
  },
  {
    name: 'Fading Balls',
    link: 'https://codepen.io/supah/full/yLermNo',
    tags: ['webgl', 'threejs', 'shaders', 'codepen'],
    image: 'images/fading-balls.webp',
  },
  {
    name: 'Flying Lotus',
    link: 'https://codepen.io/supah/full/GRgOgpM',
    tags: ['canvas', 'codepen'],
    image: 'images/flying-lotus.webp',
  },
  {
    name: 'Flowfield Circle',
    link: 'https://codepen.io/supah/full/GRgOgpM',
    tags: ['canvas', 'codepen'],
    image: 'images/flowfield-circle.webp',
  },
  {
    name: 'Flowfield Triangle',
    link: 'https://codepen.io/supah/pen/jOJqLRv',
    tags: ['canvas', 'codepen'],
    image: 'images/flowfield-triangle.webp',
  },
  {
    name: 'Frosted Glass',
    link: 'https://www.shadertoy.com/view/7tyyDy',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/froted-glass.webp',
  },
  
  {
    name: 'Ghosted O',
    link: 'https://www.shadertoy.com/view/NtyyWW',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/ghosted-o.webp',
  },
  {
    name: 'Glitchbrush',
    link: 'https://www.supah.it/glitchbrush/',
    tags: ['canvas', 'codepen'],
    image: 'images/glitchbrush.webp',
  },
  /* {
    name: 'GLSL Geometric Experiment #1',
    link: 'https://www.shadertoy.com/view/7syczd',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/geometric-1.webp',
  }, */
  {
    name: 'GLSL Geometric Experiment #2',
    link: 'https://www.shadertoy.com/view/sscXRN',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/geometric-2.webp',
  },
  {
    name: 'Gradient Snake',
    link: 'https://www.shadertoy.com/view/dtfXDr',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/gradient-snake.webp',
  },
  /* {
    name: 'Gradient Snake v2',
    link: 'https://www.shadertoy.com/view/DlB3Ry',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/gradient-snake-2.webp',
  }, */
  /* {
    name: 'Halo',
    link: 'https://www.shadertoy.com/view/fdSBDD',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/halo.webp',
  }, */
  {
    name: 'Infinite',
    link: 'https://www.supah.it/infinite/',
    tags: ['webgl', 'threejs', 'shaders'],
    image: 'images/infinite.webp',
  },
  /* {
    name: 'Infinity Grid',
    link: 'https://www.supah.it/infinity-grid/',
    tags: ['webgl', 'threejs', 'shaders'],
    image: 'images/infinity-grid.webp',
  }, */
  {
    name: 'Inside Outside',
    link: 'https://www.supah.it/inside-outside/',
    tags: ['webgl', 'threejs', 'shaders'],
    image: 'images/inside-outside.webp',
  },
  {
    name: 'Jelly Buttons',
    link: 'https://fzird.csb.app/',
    tags: ['css', 'react'],
    image: 'images/jelly-buttons.webp',
  },
  {
    name: 'Knotipse',
    link: 'https://www.supah.it/knotipse/',
    tags: ['canvas'],
    image: 'images/knotipse.webp',
  },
  /* {
    name: 'Loader Gooey',
    link: 'https://www.shadertoy.com/view/flKczt',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/loader-gooey.webp',
  }, */
  /* {
    name: 'Laser Game 1',
    link: 'https://www.shadertoy.com/view/fdcSzH',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/lasergame-1.webp',
  }, */
  {
    name: 'Laser Game 2',
    link: 'https://www.shadertoy.com/view/ss3XR8',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/lasergame-2.webp',
  },
  /* {
    name: 'Lights race',
    link: 'https://www.shadertoy.com/view/sscSWf',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/lightsrace.webp',
  }, */
  /* {
    name: 'Loop noise glsl',
    link: 'https://www.shadertoy.com/view/wdffRl',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/loopnoise-glsl.webp',
  }, */
  {
    name: 'Lotus',
    link: 'https://codepen.io/supah/full/PomKKMB',
    tags: ['css', 'codepen'],
    image: 'images/lotus.webp',
  },
  {
    name: 'Magma',
    link: 'https://www.supah.it/magma/',
    tags: ['webgl', 'threejs', 'shaders'],
    image: 'images/infinite.webp',
  },
  /* {
    name: 'Mask with mouse glsl',
    link: 'https://www.shadertoy.com/view/7tGGWD',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/mask-mouse-glsl.webp',
  }, */
  /* {
    name: 'Mitosys SVG',
    link: 'https://codepen.io/supah/full/oaEZqg',
    tags: ['svg', 'codepen'],
    image: 'images/mitosys.webp',
  }, */
  {
    name: 'Mouse Condensation',
    link: 'https://www.shadertoy.com/view/7lcfDM',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/mouse-condensation.webp',
  },
  /* {
    name: 'Noisey Lines',
    link: 'https://www.shadertoy.com/view/7dcSzN',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/noisey-lines.webp',
  }, */
  {
    name: 'Noisey Lines 2',
    link: 'https://www.shadertoy.com/view/DsfGRB',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/noisey-lines-2.webp',
  },
  {
    name: 'Okay Dev',
    link: 'https://codepen.io/supah/full/zYBNxEL',
    tags: ['canvas', 'codepen'],
    image: 'images/okay-dev.webp',
  },
  {
    name: 'Oval',
    link: 'https://www.supah.it/oval/',
    tags: ['webgl', 'threejs', 'shaders'],
    image: 'images/oval.webp'
  },
  {
    name: 'Parametric Spider',
    link: 'https://codepen.io/supah/full/vYdwbQK',
    tags: ['canvas', 'codepen'],
    image: 'images/parametric-spider.webp'
  },
  /* {
    name: 'Petals',
    link: 'https://www.shadertoy.com/view/fdtSW2',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/petals.webp'
  }, */
  {
    name: 'Playground',
    link: 'https://9cenu.csb.app/',
    tags: ['webgl', 'threejs', 'shaders'],
    image: 'images/playground.webp'
  },
  /* {
    name: 'Quarantine',
    link: 'https://www.shadertoy.com/view/3slyRN',
    tags: ['webgl', 'threejs', 'shaders'],
    image: 'images/quarantine-ball.webp'
  }, */
  /* {
    name: 'Radial Lines',
    link: 'https://www.shadertoy.com/view/dsXXWf',
    tags: ['webgl', 'threejs', 'shaders'],
    image: 'images/radial-lines.webp'
  }, */
  /* {
    name: 'React Supah Slider',
    link: 'https://www.supah.it/react-supah-slider/',
    tags: ['react', 'slider'],
    image: 'images/react-supah-slider.webp'
  }, */
  {
    name: 'Refraction',
    link: 'https://www.supah.it/refraction/',
    tags: ['webgl', 'threejs', 'shaders'],
    image: 'images/refraction.webp'
  },
  {
    name: 'Ruscello',
    link: 'https://www.shadertoy.com/view/ddGSRV',
    tags: ['webgl', 'threejs', 'shaders'],
    image: 'images/ruscello.webp'
  },
  /* {
    name: 'Ring Twist',
    link: 'https://miig4.csb.app/',
    tags: ['webgl', 'threejs', 'shaders'],
    image: 'images/ring-twist.webp'
  }, */
  {
    name: 'Scrolling Rainbow',
    link: 'https://codepen.io/supah/full/rNYeREV',
    tags: ['css', 'codepen'],
    image: 'images/scrolling-rainbow.webp'
  },
  {
    name: 'Shader Gizmo',
    link: 'https://www.supah.it/shadergizmo',
    tags: ['webgl', 'threejs', 'shaders'],
    image: 'images/shader-gizmo.webp'
  },
  {
    name: 'Smokey',
    link: 'https://codepen.io/supah/full/mdPGNQr',
    tags: ['canvas', 'codepen'],
    image: 'images/smokey.webp'
  },
  {
    name: 'Spiral',
    link: 'https://www.supah.it/spiral/',
    tags: ['webgl', 'threejs', 'shaders'],
    image: 'images/vortex.webp'
  },
  {
    name: 'The Line Game',
    link: 'https://codepen.io/supah/full/povxOYJ',
    tags: ['canvas', 'codepen'],
    image: 'images/the-line-game.webp'
  },
  {
    name: 'Torus Spiral',
    link: 'https://www.supah.it/torus-spiral/',
    tags: ['webgl', 'threejs', 'shaders'],
    image: 'images/torus-spiral.webp'
  },
  {
    name: 'Twist & Shout',
    link: 'https://www.supah.it/twistshout/',
    tags: ['webgl', 'threejs', 'shaders'],
    image: 'images/twist-shout.webp'
  },
  /* {
    name: 'Vortex Particles',
    link: 'https://www.supah.it/vortex-particles/',
    tags: ['webgl', 'threejs', 'shaders'],
    image: 'images/vortex-particles.webp'
  }, */
  {
    name: 'Watch',
    link: 'https://www.shadertoy.com/view/ddSGzd',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/watch.webp',
  },
  {
    name: 'Waves are lines',
    link: 'https://www.shadertoy.com/view/ctKyRV',
    tags: ['webgl', 'shadertoy', 'shaders'],
    image: 'images/waves-are-lines.webp',
  },
]

export default experiments
